<template>
    <div>
        <div>
            <div class="common-search">
                <el-input
                        class="common-el-input"
                        placeholder="请输入玩家ID查询"
                        v-model="searchVal">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="getList()">搜索</el-button>
            </div>
        </div>
        <div class="common-table">
            <el-table v-loading="loading" :data="accountPayeeList.beanList" height="100%" row-key="userRandomId">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="玩家昵称" width="120" align="center" prop="userNickname"/>
                <el-table-column label="玩家ID" width="120" align="center" prop="userRandomId"/>
                <el-table-column label="俱乐部昵称" min-width="180" align="center" prop="clubName"/>
                <el-table-column label="俱乐部ID" align="center" prop="clubRandomId"/>
                <el-table-column label="联盟昵称" min-width="150" align="center" prop="tribeName"/>
                <el-table-column label="联盟ID" align="center" prop="tribeRandomId"/>
                <el-table-column label="支付宝" width="180" align="center" prop="alipayAcc"/>
                <el-table-column label="银行卡" width="180" align="center" prop="bankAccNo"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="accountPayeeList.total"
                :current-page="currentPage"
                @current-change="getList({page:$event})"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                searchVal: '',
                currentPage:1
            }
        },
        computed: {
            ...mapState('accountPayee', ['accountPayeeList'])
        },
        created() {
            this.getList();
        },
        methods: {
            ...mapActions('accountPayee', ['getAccountPayeeList']),
            getList(obj = {}) {
                this.loading = true;
                let params = {
                    userRandomId: this.searchVal,
                    page: 1
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getAccountPayeeList(params).then(() => {
                    this.loading = false;
                })
            },
        }
    }
</script>